import { ASSIGNEE_LIST, CHANGE_ASSIGNEE, ASSIGNEE } from "./type";

const initalState = {
  assigneeList: [],
  gateData: {},
  assign: [],
};

const assigneeReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ASSIGNEE_LIST:
      return {
        ...state,
        assigneeList: payload,
      };
      case CHANGE_ASSIGNEE:
      return {
        ...state,
        gateData: payload,
      }
      case ASSIGNEE:
        return {
          ...state,
          assign: payload,
        }
    default:
      return {
        ...state,
      };
  }
};

export default assigneeReducer;
